import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import './footer.scss';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';

export interface DisclaimerLinks {
  customUrl: string;
  label: string;
  newTab: boolean;
  protocol: string;
  selectedRoute: string;
}

export interface FooterProps {
  disclaimerCopy: string;
  disclaimerLinks: Array<DisclaimerLinks>;
}
const formatDisclaimerCopy = (disclaimerCopy: string) => {
  if (disclaimerCopy) {
    let currentYear = new Date().getFullYear();
    const regex = /<\$CURRENT_YEAR>/ig;
    return disclaimerCopy.replace(regex, currentYear.toString(10));
  } 
  return;
};

export const Footer: React.SFC<FooterProps> = props => {

  return (
    <footer className="main-footer footer-body no-print">
      <Container className="no-print">
        <Row>
          <Col className="disclaimer-col">{formatDisclaimerCopy(props.disclaimerCopy)}</Col>
        </Row>
        <Row className="disclaimer-links">
          <Col className="disclaimer-col">
            {props.disclaimerLinks &&
              props.disclaimerLinks.map((disclaimer, index) => {
                let link = disclaimer.customUrl ? `${disclaimer.protocol}${disclaimer.customUrl}` : `/accounts/${disclaimer.selectedRoute}`;
                return (
                  <div key={index + 1} className="disclaimer-link">
                    <a
                      key={index}
                      href={link}
                      target={disclaimer.newTab ? '_blank' : ''}
                    >
                      {disclaimer.label}
                    </a>
                  </div>
                );
              })}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

const mapState = state => {
  let footerData = getAdminConfigTableItem(
    state.adminConfig,
    state.clientConfig,
    'PageFooter',
  );
  return {
    disclaimerCopy: footerData.DisclaimerCopy,
    disclaimerLinks: footerData.DisclaimerLinks,
  };
};

export default connect(mapState)(Footer);
